{
  "UnifiedNavigation": "Experience Cloud에서 탐색",
  "adobeExperienceCloudNoOrgsSelect": "다른 조직 계정 선택",
  "help": "도움말",
  "ok": "확인",
  "profile": "프로필",
  "searchButton": "검색",
  "sidenavMenuCloseTooltip": "메뉴 닫기",
  "sidenavMenuLockTooltip": "메뉴를 잠그려면 클릭하십시오.",
  "solutionSwitcher": "다른 솔루션으로 전환",
  "themeCoachMark": "밝은 테마",
  "themeCoachMarkMessage": "이제 Experience Cloud 헤더가 밝은 테마와 어두운 테마를 지원합니다. 원하는 테마로 전환하려면 내 아바타를 클릭하세요.",
  "toggleSideNav": "측면 탐색 메뉴 전환"
}
